/**
 * @file Bonus Streak Configuration
 * @description Constants for the bonus streak indicator feature
 */

/**
 * Configuration for the bonus streak indicator
 */
export const BONUS_STREAK_CONFIG = {
  /**
   * Default time efficiency threshold for streak calculation (seconds)
   * This is the default value, can be overridden by game config
   */
  DEFAULT_STREAK_TIMEOUT: 3,

  /**
   * Time window to maintain streak display (seconds)
   */
  STREAK_TIMEOUT: 5,

  /**
   * Minimum consecutive finds to activate streak indicator
   */
  MIN_STREAK_LENGTH: 1,

  /**
   * Animation durations (milliseconds)
   */
  FADE_OUT_DURATION: 500, // 0.5 seconds

  /**
   * Progress bar update interval (milliseconds)
   */
  PROGRESS_UPDATE_INTERVAL: 100, // Update every 100ms for smooth animation
};
